// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1s0p-","head":"Table_head__2J_XN","col":"Table_col__1OkRn"};